// Per-room Architectural questions for the "Box" scope delivery method's
// detail module (src/pages/estimate/ArchitecturalRoomsPanel.jsx). Answers are
// stored as a JSON object keyed by `key` below, each value a string array
// (ScopeArchRooms.ArchAnswersJson, db/98_architectural_room_details.sql) — DB
// stores only values, so adding, removing, or re-labeling a question here is
// a frontend-only change. allowOther renders a free-text input whose typed
// value is appended to the array in place of the literal word "Other".

export const ARCHITECTURAL_QUESTIONS = [
  {
    key: "room_type",
    label: "Room Type",
    options: ["Lab", "Filler", "Material Airlock", "Personnel Airlock", "Corridor"],
    allowOther: true,
  },
  {
    key: "wall_material",
    label: "Wall Material",
    options: [
      'CleanSpace Apex 1/2" Liner Wall Panel System',
      "CleanSpace Apex 2' Modular Wall Panel System",
      '3/8" GYP Board & Metal Stud',
    ],
    allowOther: true,
  },
  {
    key: "ceiling_material",
    label: "Ceiling Material",
    options: [
      'CleanSpace Apex 1/2" Non-Walkable Ceiling Panel System',
      'CleanSpace Apex 2" Modular Walkable Ceiling Panel System',
      "Grid and Tile Ceiling",
    ],
    allowOther: true,
  },
  {
    key: "door_types",
    label: "Door Types",
    options: [
      "CleanSpace Portal Core Single Swing PVC Door w/ Aluminum Frame (3' x 7')",
      "CleanSpace Portal Core Double Swing PVC Door w/ Aluminum Frame (6' x 7')",
      "CleanSpace Portal Pro Single Swing PVC Door w/ Stainless Steel Frame (3' x 7')",
      "CleanSpace Portal Core Double Swing PVC Door w/ Stainless Steel Frame (6' x 7')",
      "Single Swing Hollow Metal Door (3' x 7')",
      "Double Swing Hollow Metal Door (6' x 7')",
    ],
    allowOther: true,
  },
  {
    key: "lights",
    label: "Lights",
    options: [
      "2' x 4' Cleanroom Recessed LED Lighting",
      "2' x 2' Cleanroom Recessed LED Lighting",
      "2' x 4' Cleanroom Walkable Recessed LED Lighting",
      "2' x 2' Cleanroom Walkable Recessed LED Lighting",
      "LED Exit Lights",
    ],
    allowOther: true,
  },
  {
    key: "hepas",
    label: "HEPAs",
    options: [
      "2' x 4' Camfil Pharmaslim",
      "2' x 2' Camfil Pharmaslim",
      "2' x 4' Camfil Pharmaseal",
      "2' x 2' Camfil Pharmaseal",
      "2' x 4' FFU",
      "2' x 2' FFU",
      "2' x 2' Diffuser Boxes",
    ],
    allowOther: true,
  },
  {
    key: "wall_protection",
    label: "Wall Protection",
    options: [
      "SS Wall Mounted Bumper Rail",
      "PVC Wall Mounted Bumper Rail",
      "SS Floor Mounted Bumper Rail",
      "PVC Floor Mounted Bumper Rail",
      "SS Corner Guards (4' x 4' x 48')",
    ],
    allowOther: true,
  },
];
